import React, {useEffect, useState, useRef} from 'react';
import {ClipboardText, HouseSimple, SolarRoof, Wall} from '@phosphor-icons/react';
import {Tab} from '../../../../components';
import {useCurrentUser} from '../../../../contexts/UserContext';
import RoofProperties from './RoofProperties';
import RoofShingles from './RoofShingles';
import WallSiding from './WallSiding';
import {useViewerStore} from "../../../../store/store";
import PopoutWindow from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/PopoutWindow";
import RoofSquareTable
    from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/Roof-Square-Popout/Roof Square/RoofSquareTable";
import {registerRef} from "../../../../helpers/storeHelpers";
import { TabItem } from '../../../../@types/types';


const Roof: React.FC = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const {user, hasCapability} = useCurrentUser();
    const [panes, setPanes] = useState([]);
    const [items, setItems] = useState<TabItem[]>([{
        icon: (<ClipboardText size={24} weight='fill'/>),
        content: (<RoofProperties/>),
        id: 'roofPropertiesTabIcon',
        title: 'Roof Properties',
        is_active: true,
    }]);


    useEffect(() => {
        if (!user) return;
        const newItems: TabItem[] = [
            {
                icon: (<ClipboardText size={24} weight='fill'/>),
                content: (
                    <RoofProperties/>
                ),
                id: 'roofPropertiesTabIcon',
                title: 'Roof Properties',
                is_active: true,
            }
        ];

        if (hasCapability('View_Roof_Square')) {
            newItems.push({
                icon: (<SolarRoof size={24} weight='fill'/>),
                content: (
                    <RoofSquareTable
                        isAttachedInSidebar={true}
                    />
                ),
                title: 'Roof Square',
                id: 'roofSquareTabIcon',
                ref : registerRef("roofSquareTabIcon"),
                onActiveCallback: () => {
                    useViewerStore.setState({isMoveRoofActive: false});
                    sceneViewer.setMoveMode(false);
                },
                is_active: false,
            });
        }

        if (hasCapability('Toggle_Shingle')) {
            newItems.push({
                icon: (<HouseSimple size={24} weight='fill'/>),
                content: (<RoofShingles/>),
                title: 'Roof Shingles',
                id: 'roofShingleTabIcon',
                ref : registerRef("roofShingleTabIcon"),
                onActiveCallback: () => {
                    useViewerStore.setState({isMoveRoofActive: false});
                    sceneViewer.setMoveMode(false);
                },
                is_active: false,
            });
        }

        if (hasCapability('Toggle_Siding')) {
            newItems.push({
                icon: (<Wall size={24} weight='fill'/>),
                content: (<WallSiding/>),
                title: 'Wall Sliding',
                id: 'wallSidingTabIcon',
                onActiveCallback: () => {
                    useViewerStore.setState({isMoveRoofActive: false});
                    sceneViewer.setMoveMode(false);
                },
                is_active: false,
            });
        }
        setItems(newItems);
        if (sceneViewer) sceneViewer.setTabInfo('Roof Properties');
    }, [user, sceneViewer]);


    return (
        <>
            <Tab items={items}/>
            {
                hasCapability('View_Roof_Square') && <PopoutWindow
                    buttonID={'roofSquareTableButton'}
                    iconForButton={<SolarRoof size={28} />}
                    isOpenByDefault={false}
                    panes={panes}
                    tooltip={'Show Roof Square Table'}
                    isTabBasedContent={false}
                    tabTitle={'Roof Square Table'}
                    children={<RoofSquareTable isAttachedInSidebar={false} />} className=''                />
            }
        </>
    );
}

export default Roof;